import React, { useMemo, CSSProperties, ReactNode } from "react";
import { escapeRegExp } from "lodash";

export const useHighlighter = (
  text: string | null | undefined = "",
  search: string | null | undefined = "",
  overrideStyle: CSSProperties = {
    color: "var(--cp-color-app-primary)",
    backgroundColor: "transparent",
  },
): ReactNode => {
  return useMemo(() => {
    const safeText = text?.toString() ?? "";
    const safeSearch = search?.toString().trim() ?? "";
    const searchLower = safeSearch?.toLowerCase();
    const textLower = safeText.toLowerCase();

    if (
      !safeSearch ||
      safeSearch.length === 0 ||
      !textLower.includes(searchLower)
    ) {
      return <span>{safeText}</span>;
    }

    const sections = safeText
      .replace(new RegExp(escapeRegExp(safeSearch), "ig"), "*$&*")
      .split("*");

    return (
      <span>
        {sections.map((segment, index) => {
          const safeSegment = segment?.toString() ?? "";
          if (searchLower === safeSegment.toLowerCase()) {
            return (
              <strong style={overrideStyle} key={index}>
                {safeSegment}
              </strong>
            );
          }
          return <span key={index}>{safeSegment}</span>;
        })}
      </span>
    );
  }, [search, text, overrideStyle]);
};
